export default __webpack_public_path__ + "static/media/Mentor.ed9956b7.png";